import React from 'react';
import { RepeatIcon } from 'lucide-react';

interface RecurringIndicatorProps {
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
  className?: string;
}

/**
 * Badge component to indicate that a reminder is part of a recurring series
 */
export function RecurringIndicator({
  size = 'sm',
  showText = false,
  className = '',
}: RecurringIndicatorProps) {
  const sizeClasses = {
    sm: 'h-3 w-3',
    md: 'h-4 w-4',
    lg: 'h-5 w-5',
  };

  const containerSizeClasses = {
    sm: 'px-1.5 py-0.5 text-xs',
    md: 'px-2 py-1 text-sm',
    lg: 'px-2.5 py-1.5 text-base',
  };

  return (
    <span
      className={`inline-flex items-center gap-1 bg-blue-100 text-blue-700 rounded-full font-medium ${containerSizeClasses[size]} ${className}`}
      title="Recurring reminder"
    >
      <RepeatIcon className={sizeClasses[size]} />
      {showText && <span>Recurring</span>}
    </span>
  );
}
